export default __webpack_public_path__ + "static/media/nhlFantasyPWRSmobileDark.00371274.png";